import { instance } from "api/apiBase";
import {
  GetTemplatesResponse,
  TemplateResponse,
  VerificationSchemasResponse
} from "./types";
import { Template } from "types/landlord/verificationTemplate";

const api = {
  getTemplates: async (
    page: number,
    per_page?: number
  ): Promise<GetTemplatesResponse> => {
    return (
      await instance.get(`/portal/v1/verification_templates`, {
        params: { page, per_page }
      })
    ).data;
  },
  getTemplate: async (templateId: string): Promise<TemplateResponse> => {
    return (
      await instance.get(`/portal/v1/verification_templates/${templateId}`)
    ).data;
  },
  updateTemplate: async (
    templateId: string,
    data: Template
  ): Promise<TemplateResponse> => {
    return (
      await instance.put(
        `/portal/v1/verification_templates/${templateId}`,
        data
      )
    ).data;
  },
  deleteTemplate: async (templateId: string): Promise<boolean> => {
    return (
      await instance.delete(`/portal/v1/verification_templates/${templateId}`)
    ).data;
  },
  createTemplate: async (data: Template): Promise<TemplateResponse> => {
    return (await instance.post(`/portal/v1/verification_templates/`, data))
      .data;
  },
  validateTemplate: async (data: Template): Promise<TemplateResponse> => {
    return (
      await instance.post(`/portal/v1/verification_templates/validate`, data)
    ).data;
  },
  getVerificationSchemas: async (): Promise<VerificationSchemasResponse> => {
    return (
      await instance.get(
        `/portal/v1/verification_templates/verification_schemas`
      )
    ).data;
  },
  getDefaultTemplate: async (): Promise<TemplateResponse> => {
    return (await instance.get(`/portal/v1/verification_templates/default`))
      .data;
  },
  setDefaultTemplate: async (templateId: string) => {
    return (
      await instance.post(
        `/portal/v1/verification_templates/${templateId}/set_default`
      )
    ).data;
  },
  getDefaultCriteria: async () => {
    return (await instance.get(`/portal/v1/criteria/defaults`)).data;
  }
};

export default api;
